import { gql } from '@apollo/client/core';

export const CONNECTION_METADATA_FIELDS = gql`
  fragment ConnectionMetadataFields on PageInfo {
    hasNextPage
    hasPreviousPage
    startCursor
    endCursor
  }
`;

export type ConnectionArguments = {
  after?: string;
  before?: string;
  first?: number;
};
